export default {
  container: {
    light:
      'vc-border vc-border-gray-400 vc-bg-white vc-calendar-wrapper'
  },
  header: {
    light: 'bg-color-grey-soft'
  },
  title: {
    light: 'text-12'
  },
  arrows: {
    light:
      'vc-border-transparent hover:vc-opacity-50 color-primary'
  },
  weekdays: {
    light: 'vc-text-sm vc-font-bold color-grey-cool-two'
  },
  navPopoverContainer: {
    light:
      'vc-text-sm vc-font-semibold vc-text-white vc-bg-gray-800 vc-border vc-border-gray-700 vc-p-1 vc-shadow'
  },
  navTitle: {
    light:
      'color-primary vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-border-2 vc-border-transparent hover:vc-bg-gray-900 border-color-primary'
  },
  navArrows: {
    light:
      'vc-leading-snug vc-border-2 vc-border-transparent color-primary'
  },
  navCell: {
    light:
      'vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-border-2 vc-border-transparent hover:vc-bg-gray-900 hover:vc-shadow-inner hover:vc-text-white border-color-primary'
  },
  navCellInactive: 'vc-border-transparent',
  navCellInactiveCurrent: {
    light: 'color-primary border-color-primary'
  },
  navCellActive: {
    light:
      'color-black vc-border-transparent vc-shadow'
  },
  dayNotInMonth: 'vc-opacity-0 vc-pointer-events-none',
  dayContent:
    'text-12 color-black vc-rounded-full',
  dayContentDisabled: {
    light: 'vc-day-disabled color-grey-cool-two text-12'
  },
  dayPopoverContainer: {
    light:
      'text-12 vc-border'
  },
  dayPopoverHeader: {
    light: 'vc-text-xs vc-font-semibold'
  },
  highlightBaseFillMode: 'light',
  highlightStartEndFillMode: 'solid',
  highlightStartEndClass: 'vc-rounded-full',
  bgLow: {
    light: 'vc-bg-white vc-border-2 border-color-primary'
  },
  bgAccentLow: {
    light: 'border-color-primary'
  },
  bgAccentHigh: {
    light: 'border-color-primary'
  },
  contentAccent: {
    light: 'vc-font-bold color-primary'
  },
  contentAccentContrast: 'vc-font-bold vc-text-white',
  datePickerInput:
    'vc-shadow vc-appearance-none vc-border vc-w-full vc-py-2 vc-px-3 vc-bg-white vc-leading-tight focus:vc-outline-none focus:vc-shadow-outline',
  datePickerInputDrag:
    'vc-shadow vc-appearance-none vc-border vc-w-full vc-py-2 vc-px-3 vc-bg-white vc-leading-tight focus:vc-outline-none focus:vc-shadow-outline'
}
